/**
 * Cover Selector
 */

//
// Utilities
import debug from "debug";
import "./components/cover-selector/index";
import "./components/quote-form/index--split";
import "./components/validate-form/index--split";

import uniqueId from 'lodash/uniqueId';
const MODULE_NAME = 'cover-selector';
const log = debug(MODULE_NAME);

/**
 * Initialises the product selector.
 * @param {Element} element
 */
export default function init (element) {
	log('init', element);
	element.id = uniqueId('cover-selector');

	// TODO initialise components of the cover-selector

	return element;
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/cover-selector/index.js